export default __webpack_public_path__ + "static/media/wateringcan.acf79211.svg";